import { z } from "zod";

export const ContactSchema = z.object({
  id: z.string().optional(),
  prestataire_id: z.string().optional(),
  prenom: z.string().optional(),
  nom: z.string().optional(),
  email: z.string().optional(),
  telephone: z.string().optional(),
  role: z.string().optional(),
  created_at: z.string().optional(),
  updated_at: z.string().optional(),
});
export type ContactRow = z.infer<typeof ContactSchema>;

export const PrestataireSchema = z.object({
  id: z.string(),
  nom: z.string().optional(),
  ville: z.string().optional(),
  statut: z.string().optional(),
  email: z.string().optional(),
  telephone: z.string().optional(),
  siteWeb: z.string().optional(),
  tva: z.string().optional(),
  adresse: z.string().optional(),
  codePostal: z.string().optional(),
  regions: z.array(z.string()).optional(),
  notes: z.string().optional(),
  metiers: z.array(z.string()).optional(),  // résolu via prestataires_metiers côté repository
  contacts: z.array(ContactSchema).optional(),  // hydraté via get_contacts_for_prestataire
  created_at: z.string().optional(),
  updated_at: z.string().optional(),
});
export type PrestataireRow = z.infer<typeof PrestataireSchema>;

export const PrestataireUpdateSchema = PrestataireSchema
  .omit({ id: true, created_at: true, updated_at: true, metiers: true, contacts: true })
  .partial();
export type PrestataireUpdate = z.infer<typeof PrestataireUpdateSchema>;
